module.exports = ".card2 .card-header .card-header-right .card-option {\n  width: 190px;\n  -webkit-transition: unset;\n  transition: unset; }\n\n.card2 .card-header + .card-block-hid .card-block,\n.card2 .card-header + .card-block-hid .card-block-big,\n.card2 .card-header + .card-block-hid .card-block-small {\n  padding-top: 0; }\n\n.brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right; }\n\n.editicon {\n  margin-top: 2%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-work-details/master-work-details.component.scss
// module id = ./src/app/master/master-work-details/master-work-details.component.scss
// module chunks = main